import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=7e97a3ba&"
import script from "./Loader.vue?vue&type=script&lang=ts&"
export * from "./Loader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Buildserver\\Agent01\\_work\\1030\\s\\JCD.Retail.Webshop\\App\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e97a3ba')) {
      api.createRecord('7e97a3ba', component.options)
    } else {
      api.reload('7e97a3ba', component.options)
    }
    module.hot.accept("./Loader.vue?vue&type=template&id=7e97a3ba&", function () {
      api.rerender('7e97a3ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/webshop/components/utilities/Loader.vue"
export default component.exports